import React from 'react'
import { useTranslation } from 'react-i18next'

/** Material UI **/
import {
  Box,
  makeStyles,
  Grid,
  Typography
} from '@material-ui/core'
import { appLogo } from '../lib/Constants'

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 50,
    font: 'Rubik',
    fontWeight: 400,
    textAlign: 'start',
    paddingTop: '40px',
    lineHeight: '40px',
    marginLeft: '2rem',
    marginRight: '2rem',
    color: theme.colors.black
  },
  ad: {
    color: 'gray'
  },
  subText: {
    fontSize: 14,
    lineHeight: '17px',
    margin: '0 2rem',
    color: theme.colors.black
  },
  containerLogo: {
    position: 'absolute !important',
    left: '15px',
    top: '15px',
    [theme.breakpoints.down('sm')]: {
      position: 'relative !important',
      left: 0,
      right: 0,
      marginleft: 'auto',
      marginright: 'auto',
      marginBottom: '20px'
    }
  },
  logo: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    height: '50px',
    [theme.breakpoints.down('sm')]: {
      height: '50px'
    }
  },
  headerTitle: {
    fontWeight: '700',
    fontSize: '28px',
    textAlign: 'center',
    marginBottom: '10px',
    color: theme.colors.black
  }
}))

const LandingSetupHeader = () => {
  const { t } = useTranslation()

  const classes = useStyles()
  return (
    <>
      <Grid className={classes.containerLogo} item xs={12}>
        <img
          alt={'MyWork'}
          className={classes.logo}
          src={appLogo}
        />
      </Grid>
      <Box>
        <Grid item xs={12}>
            <Typography className={classes.headerTitle}>
              {t('landing_setup.title')}
            </Typography>
        </Grid>
        <p className={classes.subText}>
        {t('landing_setup.subtitle')}
        </p>
      </Box>
    </>
  )
}

export default LandingSetupHeader
